import { Component, ReactNode } from 'react';

import { sendGlobalErrorProps } from 'cu-master-layout-prop-manager';

import { Page404 } from '@/pages';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public static getDerivedStateFromError(_: Error): State {
    return {
      hasError: true,
    };
  }

  public componentDidCatch() {
    sendGlobalErrorProps({
      errorType: 'generalError',
    });
  }

  render() {
    return this.state.hasError ? <Page404 /> : this.props.children;
  }
}
